import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, useState, } from 'react';
import { Typography, Box } from '@mui/material';
import { lazy } from 'react';
import * as commands from '@uiw/react-md-editor';
import rehypeSanitize from 'rehype-sanitize';
import { styled } from '@mui/material/styles';
import './styles/markdown-editor.css';
import './styles/markdown-preview.css';
const MDEditor = lazy(() => import('@uiw/react-md-editor').then((mod) => ({ default: mod.default })));
const COMMAND_MAPPING = {
    bold: commands.bold,
    italic: commands.italic,
    strikethrough: commands.strikethrough,
    hr: commands.hr,
    titles: commands.group([
        commands.heading1,
        commands.heading2,
        commands.heading3,
        commands.heading4,
        commands.heading5,
        commands.heading6,
    ], {
        name: 'title',
        groupName: 'title',
        buttonProps: { 'aria-label': 'Insert title' },
    }),
    divider: commands.divider,
    link: commands.link,
    quote: commands.quote,
    code: commands.code,
    codeBlock: commands.codeBlock,
    unorderedList: commands.unorderedListCommand,
    orderedList: commands.orderedListCommand,
    checkedList: commands.checkedListCommand,
    image: commands.image,
};
const MarkdownInputComponent = ({ label, value, defaultValue, onBlur, onChange, name, excludeCommands = [], }) => {
    const [inputValue, setInputValue] = useState(value);
    const [oldPropsValue, setOldPropsValue] = useState(value);
    if (oldPropsValue !== value) {
        setOldPropsValue(value);
        setInputValue(value);
    }
    if (value && !onChange) {
        console.warn('If you provide a value please also provide an onChange handler to fully control the component');
    }
    const handleChange = (val, event) => {
        setInputValue(val);
        onChange?.(val || '', event);
    };
    const handleBlur = (e) => {
        onBlur?.(inputValue || '', e);
    };
    const customCommands = Object.entries(COMMAND_MAPPING)
        .filter(([key]) => !excludeCommands.includes(key))
        .map(([, command]) => command);
    return (_jsxs(Box, { sx: { width: '100%' }, "data-color-mode": 'light', children: [label && (_jsx(Typography, { sx: {
                    color: 'text.secondary',
                    fontWeight: 400,
                    fontSize: '0.90rem',
                    letterSpacing: '0.00938em',
                    display: 'block',
                    marginBottom: '8px',
                    transformOrigin: 'top left',
                }, component: 'label', children: label })), _jsx(Suspense, { fallback: _jsx(Box, { children: "Loading editor..." }), children: _jsx(MDEditor, { className: 'wmde-markdown', value: inputValue, defaultValue: defaultValue, onChange: handleChange, onBlur: handleBlur, commands: customCommands, previewOptions: {
                        rehypePlugins: [[rehypeSanitize]],
                    }, components: {
                        textarea: (props) => (_jsx("textarea", { ...props, name: name })),
                    }, visibleDragbar: false }) })] }));
};
export const MarkdownInput = styled(MarkdownInputComponent)(({ theme }) => ({
    '& .wmde-markdown': {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
    },
}), { name: 'MarkdownInput' });
